// Pointy-top axial layout used by the 3D board. Inverse of movement.mjs pixel().
export const HEX_SIZE = 1;

export function axialToWorld(q, r, size = HEX_SIZE) {
  return {
    x: size * Math.sqrt(3) * (q + r / 2),
    z: size * 1.5 * r,
  };
}

function cubeRound(x, y, zc) {
  let rx = Math.round(x), ry = Math.round(y), rz = Math.round(zc);
  const dx = Math.abs(rx - x), dy = Math.abs(ry - y), dz = Math.abs(rz - zc);
  if (dx > dy && dx > dz) rx = -ry - rz;
  else if (dy > dz) ry = -rx - rz;
  return { q: rx || 0, r: ry || 0 };
}

export function worldToAxial(x, z, size = HEX_SIZE) {
  const q = (Math.sqrt(3) / 3 * x - 1 / 3 * z) / size;
  const r = (2 / 3 * z) / size;
  return cubeRound(q, r, -q - r);
}

export function boardCenter(qCount, rCount, size = HEX_SIZE) {
  const a = axialToWorld(0, 0, size);
  const b = axialToWorld(qCount - 1, rCount - 1, size);
  return { x: (a.x + b.x) / 2, z: (a.z + b.z) / 2 };
}

export function tileHeight(terrain) {
  if (terrain === "plateau") return 0.95;
  if (terrain === "mountain") return 1.05;
  if (terrain === "pit") return 0.04;
  if (terrain === "water") return 0.06;
  if (terrain === "ford") return 0.1;
  if (terrain === "hills") return 0.42;
  if (terrain === "forest") return 0.2;
  if (terrain === "ruins") return 0.34;
  if (terrain === "ore") return 0.2;
  if (terrain === "base") return 0.28;
  return 0.16;
}
